import { PricingTypes } from "../../../../../common/constants"
import { InvoicingSystem } from "../../../../../domain/invoicing/settings/invoicingSettings"
import { WorkareaGroup } from "../../../../../domain/workareas/group"
import { WorkareaQuotedPriceChange } from "../../../../../domain/workareas/groupsApi"
import { WorkareaGroupMutationData } from "../../../../../domain/workareas/groupsQueries"

export const updateGroupName = (group: WorkareaGroup, name: string): WorkareaGroupMutationData => {
  return {
    isValidUpdate: name.length > 0 && group.name !== name,
    optimisticUpdate: { id: group.id, name},
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['Name'], name, workareaQuotedPriceChanges: [] }
  }
}

export const updateGroupCustomerAndInvoiceNotes = (group: WorkareaGroup, customerAndInvoiceNotes?: string): WorkareaGroupMutationData => {
  return {
    isValidUpdate: customerAndInvoiceNotes !== group.customerAndInvoiceNotes,
    optimisticUpdate: { id: group.id, customerAndInvoiceNotes },
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['CustomerAndInvoiceNotes'], customerAndInvoiceNotes, workareaQuotedPriceChanges: [] }
  }
}

export const updateGroupInvoiceDescription = (group: WorkareaGroup, invoiceDescription: string): WorkareaGroupMutationData => {
  return {
    isValidUpdate: invoiceDescription !== (group.invoiceDescription ?? ''),
    optimisticUpdate: { id: group.id, invoiceDescription },
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['InvoiceDescription'], invoiceDescription, workareaQuotedPriceChanges: [] }
  }
}

export const updateGroupPricingType = (group: WorkareaGroup, pricingType: number): WorkareaGroupMutationData => {
  return {
    isValidUpdate: pricingType !== group.pricingType,
    optimisticUpdate: { id: group.id, pricingType },
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['PricingType'], pricingType, workareaQuotedPriceChanges: [] }
  }
}

export const updateGroupIsApproved = (group: WorkareaGroup, isApproved: boolean, workareaQuotedPriceChanges: WorkareaQuotedPriceChange[]): WorkareaGroupMutationData => {
  if(isApproved && group.isOnHold){
    return {
      isValidUpdate: isApproved !== group.isApproved,
      optimisticUpdate: { id: group.id, isApproved, isOnHold: false },
      dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['IsApproved', 'IsOnHold'], isApproved, isOnHold: false, workareaQuotedPriceChanges }
    }
  }
  else{
    return {
      isValidUpdate: isApproved !== group.isApproved,
      optimisticUpdate: { id: group.id, isApproved },
      dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['IsApproved'], isApproved, workareaQuotedPriceChanges }
    }
  }
}

export const updateGroupIsOnHold = (group: WorkareaGroup, isOnHold: boolean, workareaQuotedPriceChanges: WorkareaQuotedPriceChange[]): WorkareaGroupMutationData => {
  if(isOnHold && group.isApproved){
    return {
      isValidUpdate: isOnHold !== group.isOnHold,
      optimisticUpdate: { id: group.id, isOnHold, isApproved: false },
      dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['IsApproved', 'IsOnHold'], isOnHold, isApproved: false, workareaQuotedPriceChanges }
    }
  }
  else{
    return {
      isValidUpdate: isOnHold !== group.isOnHold,
      optimisticUpdate: { id: group.id, isOnHold },
      dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['IsOnHold'], isOnHold, workareaQuotedPriceChanges}
    }
  }
}

export const updateGroupQboSalesTaxId = (group: WorkareaGroup, qboSalesTaxId: number | undefined | null): WorkareaGroupMutationData => {
  return {
    isValidUpdate: qboSalesTaxId !== group.qboSalesTaxId,
    optimisticUpdate: { id: group.id, qboSalesTaxId },
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['QboSalesTaxId'], qboSalesTaxId, workareaQuotedPriceChanges: [] }
  }
}

export const updateShowTaxInFinalPrice = (group: WorkareaGroup, showTaxInFinalPrice: boolean): WorkareaGroupMutationData => {
  return {
    isValidUpdate: showTaxInFinalPrice !== group.showTaxInFinalPrice,
    optimisticUpdate: { id: group.id, showTaxInFinalPrice },
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['ShowTaxInFinalPrice'], showTaxInFinalPrice, workareaQuotedPriceChanges: [] }
  }
}

export const updateGroupTaxRateId = (group: WorkareaGroup, taxRateId: string | undefined | null): WorkareaGroupMutationData => {
  return {
    isValidUpdate: taxRateId !== group.taxRateId,
    optimisticUpdate: { id: group.id, taxRateId },
    dataForServer: { jobId: group.jobId, id: group.id, fieldsToUpdate: ['TaxRateId'], taxRateId, workareaQuotedPriceChanges: [] }
  }
}

export const shouldShowTaxRateSelector = (invoicingSystem: InvoicingSystem, group: WorkareaGroup) => {
  return invoicingSystem === 'synkedUp' &&
    (group.showTaxInFinalPrice || group.pricingType === PricingTypes.TimeAndMaterials || group.pricingType === PricingTypes.FlatRate)
}
